export var isMultiShadeProduct = function isMultiShadeProduct(_ref) {
  var shades = _ref.shades;
  return shades && shades.length > 1;
};
//# sourceMappingURL=isMultiShadeProduct.js.map